import React, { useEffect, useRef, useState } from "react";
import "./tickerstyle.css";
import { GetTicker, postTicker, UpdateTicker } from "../auth/service";

import { toast, ToastContainer } from "react-toastify";

export default function AnnouncementTickerUI() {
  const editorRef = useRef(null);

  const [active, setActive] = useState(true);
  const [loading, setLoading] = useState(false);

  const [fetchLoading, setFetchLoading] = useState(false);
  const [editingTicker, setEditingTicker] = useState(null);

  const format = (command, value = null) => {
    document.execCommand(command, false, value);
  };

  // const changeFontSize = (size) => {
  //   if (!size) return;

  //   document.execCommand("styleWithCSS", true); // VERY IMPORTANT
  //   document.execCommand("fontSize", false, "7"); // temporary

  //   const fonts = editorRef.current.getElementsByTagName("font");

  //   for (let i = 0; i < fonts.length; i++) {
  //     if (fonts[i].size === "7") {
  //       fonts[i].removeAttribute("size");
  //       fonts[i].style.fontSize = size + "px";
  //     }
  //   }
  // };

  // const changeFontSize = (size) => {
  //   if (!size) return;

  //   editorRef.current.focus();

  //   const selection = window.getSelection();
  //   if (!selection.rangeCount) return;

  //   const range = selection.getRangeAt(0);

  //   // ✅ Remove existing font-size spans in selection
  //   const fragment = range.extractContents();

  //   const tempDiv = document.createElement("div");
  //   tempDiv.appendChild(fragment);

  //   tempDiv.querySelectorAll("*").forEach((el) => {
  //     if (el.style) {
  //       el.style.fontSize = "";
  //     }
  //   });

  //   range.insertNode(tempDiv);

  //   // Move cursor inside again
  //   selection.removeAllRanges();
  //   const newRange = document.createRange();
  //   newRange.selectNodeContents(tempDiv);
  //   selection.addRange(newRange);

  //   // ✅ Apply new size
  //   document.execCommand("styleWithCSS", true);
  //   document.execCommand("fontSize", false, "7");

  //   const fonts = editorRef.current.querySelectorAll(
  //     'font[size="7"], span[style*="font-size"]',
  //   );

  //   fonts.forEach((el) => {
  //     el.style.fontSize = size + "px";
  //     el.removeAttribute("size");
  //   });
  // };

  const changeFontSize = (size) => {
    editorRef.current.focus();

    document.execCommand(
      "insertHTML",
      false,
      `<span style="font-size:${size}px">${window.getSelection()}</span>`,
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // const content = editorRef.current?.innerHTML?.trim();

    const htmlContent = editorRef.current?.innerHTML;
    const plainText = editorRef.current?.textContent?.trim();

    if (!plainText) {
      toast.error("Announcement cannot be empty");
      return;
    }

    const payload = {
      content: htmlContent,
      active,
    };

    // if (!content || content === "<br>") {
    //   toast.error("Announcement cannot be empty");
    //   return;
    // }

    // const payload = {
    //   content,
    //   active,
    // };

    try {
      setLoading(true);

      let res;

      // ⭐⭐⭐ THIS IS THE ONLY LOGIC CHANGE
      if (editingTicker) {
        res = await UpdateTicker(editingTicker._id, payload);
        toast.success("Ticker updated successfully");
      } else {
        res = await postTicker(payload);
        toast.success(res?.message || "Ticker saved successfully");
      }

      if (editingTicker) {
        // setEditingTicker(res?.data); // updated ticker
        const updated = res?.data;
        setEditingTicker(updated);
        setActive(updated.active);
      } else {
        // first time save
        fetchTickers();
      }
    } catch (err) {
      toast.error(err?.message || "Failed to save ticker");
    } finally {
      setLoading(false);
    }
  };

  const fetchTickers = async () => {
    try {
      setFetchLoading(true);

      const res = await GetTicker();
      const data = res?.data || [];

      if (data.length > 0) {
        const ticker = data[0];

        setEditingTicker(ticker);
        setActive(ticker.active);
      }
    } catch (err) {
      toast.error(err?.message || "Failed to fetch tickers");
    } finally {
      setFetchLoading(false);
    }
  };

  useEffect(() => {
    if (editingTicker && editorRef.current) {
      editorRef.current.innerHTML = editingTicker.content || "";
    }
  }, [editingTicker]);

  useEffect(() => {
    fetchTickers();
  }, []);

  // const handleCancel = () => {
  //   if (editingTicker && editorRef.current) {
  //     // restore last saved content
  //     editorRef.current.innerHTML = editingTicker.content || "";
  //     setActive(editingTicker.active);
  //   } else {
  //     // if no ticker exists yet → clear editor
  //     editorRef.current.innerHTML = "";
  //     setActive(true);
  //   }
  // };

  return (
    <div style={{ maxWidth: 760 }}>
      <div className="am-card">
        {/* Ticker display */}

        <div className="am-ticker">
          <div className="am-icon">📣</div>

          <div style={{ flex: 1 }}>Announcements</div>
        </div>

        {/* Admin form */}
        <form className="am-form" onSubmit={handleSubmit}>
          <div className="am-editor">
            {/* Toolbar */}
            <div className="am-editor-toolbar">
              <button
                type="button"
                className="am-editor-btn"
                onClick={() => format("bold")}
              >
                <b>B</b>
              </button>

              <button
                type="button"
                className="am-editor-btn"
                onClick={() => format("italic")}
              >
                <i>I</i>
              </button>

              <button
                type="button"
                className="am-editor-btn"
                onClick={() => format("underline")}
              >
                <u>U</u>
              </button>

              <button
                type="button"
                className="am-editor-btn"
                onClick={() => format("strikeThrough")}
              >
                <s>S</s>
              </button>

              {/* Font family */}

              {/* Font size */}
              {/* <select
                className="am-editor-select"
                onChange={(e) => changeFontSize(e.target.value)}
              >
                <option value="">Size</option>
                <option value="2">Small</option>
                <option value="3">Normal</option>
                <option value="4">Medium</option>
                <option value="5">Large</option>
                <option value="6">X-Large</option>
              </select> */}
              <select
                className="am-editor-select"
                onChange={(e) => changeFontSize(e.target.value)}
              >
                <option value="">Size</option>
                <option value="12">12px</option>
                <option value="14">14px</option>
                <option value="16">16px (Default)</option>
                <option value="18">18px</option>
                <option value="20">20px</option>
                <option value="24">24px</option>
                <option value="28">28px</option>
                <option value="32">32px</option>
              </select>
            </div>

            {/* Editable area */}
            <div
              className="am-editor-content"
              contentEditable
              suppressContentEditableWarning
              data-placeholder="Type your announcement here…"
              ref={editorRef} // ⭐⭐⭐ THIS IS MISSING
            />
          </div>

          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <div className="am-controls">
              <button type="submit" className="am-btn am-btn-primary">
                {editingTicker ? "Update" : "Save"}
              </button>
              {/* <button
                type="button"
                className="am-btn am-btn-ghost"
                onClick={handleCancel}
              >
                Cancel
              </button> */}
            </div>
          </div>

          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <label>
              <input
                type="radio"
                name="active"
                checked={active === true}
                onChange={() => setActive(true)}
              />
              Active
            </label>

            <label>
              <input
                type="radio"
                name="active"
                checked={active === false}
                onChange={() => setActive(false)}
              />
              Inactive
            </label>
          </div>
        </form>
      </div>

      {/* ===== LIVE TICKER PREVIEW ===== */}
      {/* 
      {editingTicker && (
        <div className="am-announcement-preview">
          <div className={`am-announcement ${active ? "" : "inactive"}`}>
            <div className="am-dot" />

            <div
              className="am-announcement-text"
              dangerouslySetInnerHTML={{
                __html: editingTicker.content,
              }}
            />

            <span className="am-status">{active ? "Active" : "Inactive"}</span>
          </div>
        </div>
      )} */}
      {/* <ToastContainer /> */}
    </div>
  );
}
